import { postAccountSetPublic } from "@/api/http/ins/insUser";
import store from "@/store/index";
import * as types from "@/store/constants/types";
import EventBus from "@/utils/eventBus";
import GeneralUtilsHelper from "@/utils/generalUtils";
import Vue from "vue";
import dialogTopContent from "@/components/dialog/topPicContent/topPicContent";
import { isEmpty } from "@/utils/lodash";
import VipOfferUtils from "@/utils/vipOfferUtils";

class PaymentChecker {
  public check(chain: any) {
    return new Promise((resolve, reject) => {
      try {
        //传入下来的offer:
        const offer = chain;
        const userInfo = store.getters[types.GETTER_CURRENT_INS_USER_INFO];
        let mediaInfo = null;
        if (offer.kind === "view") {
          mediaInfo = store.getters[types.GETTER_CURRENT_INS_MEDIA_INFO](
            "view"
          );
        } else {
          mediaInfo = store.getters[types.GETTER_CURRENT_INS_MEDIA_INFO](
            "post"
          );
        }
        const newChain = {
          offer,
          userInfo,
          mediaInfo
        };
        console.log("newChain:", newChain);
        //是否需要登陆:
        this.checkSignGx(newChain)
          .then((needLoginResult: any) => {
            resolve(this.needLogin(needLoginResult));
          })
          .catch(() => {
            resolve(false);
          });
      } catch (error) {
        resolve(false);
      }
    });
  }

  public checkSignGx(chain: any) {
    return new Promise(async (resolve, reject) => {
      try {
        //判断是否已经注册了GX用户，如果没有，则需要再次注册账户
        const gxUserInfo = store.getters[types.GETTER_MASTER_SERVICE_DATA];
        if (isEmpty(gxUserInfo)) {
          console.log("发现注册GX失败:");
          const masterId = store.getters[types.GETTER_DEVICE_ID];
          await store.dispatch(types.LOGIN_BY_GX, {
            masterId
          });
          resolve(chain);
        } else {
          console.log("发现注册GX成功>>:");
          resolve(chain);
        }
      } catch (error) {
        reject("Sign service failed");
      }
    });
  }

  public emptyPost(chain: any) {
    return new Promise((resolve, reject) => {
      try {
        //判断是否有post，如果没有pos提示 no post yet
        const { offer, userInfo, mediaInfo } = chain;
        const filterKind = ["like", "comment", "view", "special_like"];
        const findKind = filterKind.find((kind: any) => {
          return kind === offer.kind;
        });
        if (findKind === undefined) {
          //不属于post类型
          resolve(this.blockComment(chain));
        } else {
          //属于post类型：
          if (mediaInfo === null) {
            EventBus.$emit("toast-show", {
              type: "warning",
              content: "No post yet"
            });
            reject("No post yet"); //特殊处理 ，如果resolve(false), EventBus.$emit("toast-hide");会隐藏toast
          } else {
            resolve(this.blockComment(chain));
          }
        }
      } catch (error) {
        resolve(false);
      }
    });
  }

  public needLogin(chain: any) {
    return new Promise((resolve, reject) => {
      try {
        const { offer, userInfo, mediaInfo } = chain;
        if (GeneralUtilsHelper.isEmptyAccount()) {
          console.log("需要登陆");

          //需要做判断，如果购买的是vip或者金币，则通过验证，可以让其购买：
          if (
            offer.kind.indexOf("vip") > -1 ||
            offer.kind.indexOf("coin") > -1
          ) {
            resolve(this.coinEnough(chain));
          } else {
            store.dispatch(types.SHOW_LITE_SEARCH_OR_LOGIN);
            resolve(false);
          }
        } else {
          console.log("不需要登录");
          resolve(this.coinEnough(chain));
        }
      } catch (error) {
        resolve(false);
      }
    });
  }

  public blockComment(chain: any) {
    const { offer, userInfo, mediaInfo } = chain;
    return new Promise((resolve, reject) => {
      console.log("blockComment:", { offer, userInfo, mediaInfo });
      try {
        if (
          offer.kind === "comment" &&
          GeneralUtilsHelper.isBlockComment(mediaInfo)
        ) {
          resolve(this.blockCommentHandler(chain));
        } else {
          resolve(this.orderConfirm(chain));
        }
      } catch (error) {
        resolve(false);
      }
    });
  }

  public blockCommentHandler(chain: any) {
    const { offer, userInfo, mediaInfo } = chain;
    const { userType } = userInfo;
    const isSearch = userType === "search";
    return new Promise(async (resolve, reject) => {
      try {
        const title = "Turn On Commenting";
        const topIcon = require("@/assets/icons-file/dialog/pic_tab1_turnoncommenting.png");
        let midContent: any;
        const ContentText = Vue.extend({
          template: `<div>Please<i> Turn On Commenting of the post</i> first in order to get comments fast.</div>`
        });
        !isSearch
          ? (midContent = new ContentText())
          : (midContent =
              "In order to use our services, we do require you to turn on commenting of the post instagram’s setting first.");
        let buttons = [];
        console.log("fkfkfkfk midContent:", midContent);
        isSearch
          ? (buttons = [
              {
                text: "OK",
                clickFn: () => {
                  resolve(false);
                }
              }
            ])
          : (buttons = [
              {
                text: "TURN ON",
                clickFn: async () => {
                  //开启评论
                  await store.dispatch(types.ENABLE_POST_COMMENT, {
                    mediaId: mediaInfo.id,
                    userId: userInfo.userId
                  });
                  resolve(this.orderConfirm(chain));
                }
              },
              {
                text: "CANCEL",
                clickFn: () => {
                  resolve(false);
                }
              }
            ]);
        store.dispatch(types.DIALOG_SHOW, {
          title,
          midContent,
          buttons,
          topIcon,
          cancelFn: () => {
            resolve(false);
          }
        });
      } catch (error) {
        resolve(false);
      }
    });
  }

  //检查是否是私有账户：
  public privateAccount(chain: any) {
    const { offer, userInfo, mediaInfo } = chain;
    return new Promise((resolve, reject) => {
      try {
        if (GeneralUtilsHelper.isPirvateAccount(userInfo.insUserInfo)) {
          //私有账户：
          resolve(this.privateAccountHandler(chain));
        } else {
          //不是私有账户：
          resolve(this.emptyPost(chain));
        }
      } catch (error) {
        resolve(false);
      }
    });
  }

  public privateAccountHandler(chain: any) {
    console.log("privateAccountHandler chain:", chain);
    const { offer, userInfo, mediaInfo } = chain;
    const topIcon = require("@/assets/icons-file/dialog/private@3x.png");
    const title = "Private Account";
    console.log("privateAccountHandler userInfo:", userInfo);
    const { username } = userInfo.insUserInfo;
    const { userId } = userInfo;
    const midContent: any = "";
    let leftBtnText: string = "";
    let rightBtnText: string = "";
    let leftBtnFn: any;
    let rightBtnFn: any;
    let cancelFn: any;

    const postAccountSetPublicRequest = (resolve: any, reject: any) => {
      postAccountSetPublic(userId)
        .then((result: any) => {
          console.log("postAccountSetPublic:result", result);
          if (result.status === "ok") {
            //这时候返回的数据 需要merge到现有数据中，不能全部代替:
            store.commit(types.MERGE_INS_USER_INFO_DATA, {
              userId,
              insUserInfo: result.user
            });
            resolve(this.emptyPost(chain));
          } else {
            resolve(false);
          }
        })
        .catch((error: any) => {
          console.log("postAccountSetPublic:error", error);
          resolve(false);
        });
    };

    //如果是follow类型
    return new Promise(async (resolve, reject) => {
      try {
        const { userType } = userInfo;
        const isSearch = userType === "search";
        let emitObj: any = {};
        let template: string;
        if (offer.kind.indexOf("follow") > -1) {
          //========================== follow类型 ================================
          template = `<p>
            Your account <i>${username}</i> is set to be private. So only your
            approved followers will increase your followers count. We
            recommend you <i>set your account public temporarily</i> in order
            to get followers fast
          </p>`;
          leftBtnFn = () => {
            resolve(this.emptyPost(chain));
          };
          rightBtnFn = async () => {
            isSearch
              ? resolve(this.emptyPost(chain))
              : postAccountSetPublicRequest(resolve, reject);
          };
          leftBtnText = "CONTINUE AS PRIVATE";
          rightBtnText = "OK";
          cancelFn = () => {
            resolve(false);
          };
          const ContentText = Vue.extend({
            template
          });
          emitObj = {
            title,
            midContent: new ContentText(),
            topIcon,
            buttons: [
              {
                text: rightBtnText,
                clickFn: rightBtnFn
              },
              {
                text: leftBtnText,
                clickFn: leftBtnFn
              }
            ],
            cancelFn
          };
        } else {
          //============================ like 类型 =================================
          template = `
            <p>
              Your account <i>${username}</i> is set to be private. So only your
              approved followers will see and like your posts. We recommend you
              <i>set your account public temporarily</i> in order to get likes
              or views fast
            </p>`;
          isSearch ? false : (rightBtnText = "OK");
          isSearch ? (leftBtnText = "OK") : (leftBtnText = "CANCEL");
          leftBtnFn = () => {
            //like comment 等私有账户不能买，进行阻断
            console.log("tests:");
            resolve(false);
          };
          isSearch
            ? false
            : (rightBtnFn = async () => {
                postAccountSetPublicRequest(resolve, reject);
              });
          cancelFn = () => {
            console.log("tests xxxx:");
            resolve(false);
          };
          const ContentText = Vue.extend({
            template
          });
          isSearch
            ? (emitObj = {
                title,
                midContent: new ContentText(),
                topIcon,
                buttons: [
                  {
                    text: leftBtnText,
                    clickFn: leftBtnFn
                  }
                ],
                cancelFn
              })
            : (emitObj = {
                title,
                midContent: new ContentText(),
                topIcon,
                buttons: [
                  {
                    text: rightBtnText,
                    clickFn: rightBtnFn
                  },
                  {
                    text: leftBtnText,
                    clickFn: leftBtnFn
                  }
                ],
                cancelFn
              });
        }
        store.dispatch(types.DIALOG_SHOW, emitObj);
      } catch (error) {
        console.log("privateAccountHandler error:", error);
        resolve(false);
      }
    });
  }

  //确定大额订单
  public orderConfirm(chain: any) {
    return new Promise((resolve, reject) => {
      try {
        const { offer } = chain;
        if (offer.way === "coin" && offer.coins >= 2000) {
          resolve(this.orderConfirmHandler(chain));
        } else {
          resolve(true);
        }
      } catch (error) {
        resolve(false);
      }
    });
  }

  public orderConfirmHandler(chain: any) {
    return new Promise((resolve, reject) => {
      try {
        const { offer, userInfo, mediaInfo } = chain;
        console.log("orderConfirmHandler:", {
          userInfo,
          mediaInfo
        });
        const isPostOffer = GeneralUtilsHelper.isPostOffer(offer);
        const userPic = isPostOffer
          ? GeneralUtilsHelper.getInsPostData(mediaInfo).pic_url
          : userInfo.insUserInfo.profile_pic_url;

        store.dispatch(types.DIALOG_SHOW, {
          title: "Confirm The Order",
          topContent: dialogTopContent(
            userPic,
            isPostOffer ? "square" : "circle"
          ),
          midContent: `Are you sure to get 
          <i>${offer.effect} ${
            store.getters[types.GETTER_INFO_BY_OFFER_DATA](offer).type_name
          }</i> ？`,
          buttons: [
            {
              text: "OK",
              clickFn: () => {
                resolve(true);
              }
            },
            {
              text: "GIVE UP",
              clickFn: () => {
                resolve(false);
              }
            }
          ],
          countTime: 5000,
          delayFn: () => {
            resolve(true);
          },
          cancelFn: () => {
            resolve(false);
          }
        });
      } catch (error) {
        resolve(false);
      }
    });
  }

  public coinEnough(chain: any) {
    return new Promise((resolve, reject) => {
      const { offer } = chain;
      const userCoins = store.getters[types.GETTER_MASTER_COINS];
      const needCoins = offer.coins || 0;
      console.log("userCoins,needCoins", userCoins, needCoins);
      if (offer.way === "coin" && needCoins > userCoins) {
        console.log("show_dialog");
        store.dispatch(types.DIALOG_SHOW, {
          title: "Not Enough Coins ?",
          midContent: `Need <i>${needCoins} coins</i>, you only have <i>${userCoins} coins</i>. Would you like to get more coins?`,
          topIcon: require("@/assets/icons-file/dialog/pic_tab1_notenoughcoins@3x.png"),
          buttons: [
            {
              text: "RECHARGE",
              clickFn: () => {
                resolve(false);
                store.dispatch(types.ROUTER_PUSH, {
                  name: "CoinsStore",
                  query: {
                    tabIndex: 0
                  },
                  params: {
                    routerTransition: "up"
                  }
                });
              }
            },
            {
              text: "FREE COINS",
              color: "#8c8c8c",
              fontFamily: "WorkSans-Medium,AppleSDGothicNeo-Medium",
              clickFn: () => {
                // localStorage.setItem("coinStoreTabIndex", "1");
                // store.commit(types.SET_TAB_STATE_BY_NAME, {
                //   name: "coinStore",
                //   value: 1
                // });
                store.dispatch(types.ROUTER_PUSH, {
                  name: "CoinsStore",
                  query: {
                    tabIndex: 1
                  },
                  params: {
                    routerTransition: "up"
                  }
                });
                resolve(false);
              }
            }
          ],
          cancelFn: () => {
            resolve(false);
          }
        });
      } else {
        if (offer.kind.indexOf("coin") > -1 || offer.kind.indexOf("vip") > -1) {
          //vip或者买金币直接进入购买流程:
          console.log("vip或者买金币直接进入购买流程");
          resolve(true);
        } else {
          //检查是否是私有账户:
          resolve(this.privateAccount(chain));
        }
      }
    });
  }

  public showRewardIfNeeded(data: any) {
    const { offer, payWay } = data;
    if (offer === undefined) {
      return;
    }
    const info = store.getters[types.GETTER_INFO_BY_OFFER_DATA](offer);
    console.log("info", info);
    if (payWay === "iap" && offer.kind.includes("vip")) {
      // const firstVipService = VipOfferUtils.firstVipService();
      const servers = VipOfferUtils.boughtVip();
      const isAutoRenew = !info.offer.is_no_auto_renew;
      console.log("servers", servers);
      console.log("isAutoRenew", isAutoRenew); //type true 为试用期
      if (servers && info.coin_bonus > 0) {
        console.log("servers && info.coin_bonus > 0");
        EventBus.$emit("show-buy-Vip-send-coin", { show: true, type: false });
      } else if (!servers && info.coin_bonus > 0) {
        console.log("servers && info.coin_bonus > 0:", isAutoRenew);
        if (isAutoRenew) {
          EventBus.$emit("show-buy-Vip-send-coin", { show: true, type: true });
        } else {
          EventBus.$emit("show-buy-Vip-send-coin", { show: true, type: false });
        }
      } else if (info.reward_effect > 0) {
        const moUnit: string = info.reward_effect > 1 ? "months" : "month";
        EventBus.$emit("toast-show", {
          type: "success",
          content: `You've got extra ${
            info.reward_effect
          } ${moUnit} VIP，totally ${info.effect + info.reward_effect} moths`,
          duration: 4000
        });
      }
    }
  }
}

const checker = new PaymentChecker();
export default checker;
